/**
 * 自定义查询 - 运行时配置
 *
 * 因为路由页由 router 实例化（宿主无法通过模板 props 注入接口），
 * 这里用模块级单例保存接口与传参，宿主只需在启动时可选地调用 setCustomQueryApi 覆盖。
 */
import mockApi from './api/mock-api';
import realApi from './api/real-api';

// 路由名（宿主无需关心，内部自注册）
export var ROUTE_NAMES = {
  config: 'customQuery',
  history: 'customQueryHistory',
  result: 'customQueryResult'

  // 路由路径
};export var ROUTE_PATHS = {
  config: '/com/model/custom-query',
  history: '/com/model/custom-query-history',
  result: '/com/model/custom-query-result'

  // 「执行查询」配置页 -> 结果页 传参用 localStorage key（跨新开页面共享，sessionStorage 不随 window.open 传递）
};export var PAYLOAD_KEY = 'CUSTOM_QUERY_PAYLOAD';

/**
 * 在新页面（新标签页）打开组件内部路由
 * 同路由名复用已有标签页，不同路由各开一个独立标签页。
 * 例如：多次打开 config 页 → 复用同一标签页；config 和 history 各占一个标签页。
 *
 * 复用窗口刷新策略：在 query 上追加 _t 时间戳，确保每次 URL 都不同，
 * 这样 window.open 复用同名窗口时会自动导航到新 URL，触发 Vue 路由更新和组件刷新。
 * （不再通过 win.location.href 强制刷新，规避跨浏览器安全限制导致 win.location 不可访问的问题）
 * @param {VueRouter} router 宿主 router 实例
 * @param {Object} location 路由定位对象 { name, query }
 */
export function openRouteInNewTab(router, location) {
  if (!router) {
    return;
  }
  // 合并 _t 时间戳，保证每次 URL 唯一，复用窗口时浏览器自动刷新内容
  var query = Object.assign({}, location.query || {}, { _t: Date.now() });
  var href = router.resolve({ name: location.name, query: query }).href;
  var base = window.location.href.split('#')[0];
  var url = base + href;
  // 使用路由名作为窗口标识：同路由复用已有标签页，避免无限开窗口
  var windowName = location.name || '_blank';
  window.open(url, windowName);
}

// 当前接口实现（默认：真实接口对接的方法 + 其余回退 mock，宿主可再覆盖）
var currentApi = Object.assign({}, mockApi, realApi);

/**
 * 宿主注入真实接口（可只覆盖部分方法，未覆盖的回退 mock/内置真实接口）
 * @param {Object} api
 */
export function setCustomQueryApi(api) {
  currentApi = Object.assign({}, mockApi, realApi, api || {});
}

// 获取当前接口
export function getCustomQueryApi() {
  return currentApi;
}

// ----- 宿主 store 引用 -----
// real-api 不能静态 import '@/store'（打包后会得到一个空的 Vuex Store，没有 postRequest 等业务 action），
// 改为运行时从宿主注入：openCustomQuery 调用时由 dataGrid 组件传入 this.$store。
var hostStore = null;

/**
 * 注入宿主 Vuex store（供 real-api 内部 dispatch 使用）
 * @param {Vuex.Store} store
 */
export function setStore(store) {
  hostStore = store || hostStore;
}

/**
 * 获取宿主 store（real-api 调用 store.dispatch 时使用）
 * @returns {Vuex.Store|null}
 */
export function getStore() {
  return hostStore;
}


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/custom-query/runtime.js
// module id = 3
// module chunks = 0